/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * IntelliGems A/B Test: Mobile Product Thumbnails
 * Shows product thumbnails on mobile for test group, keeps dots for control group
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileThumbnailsABTest);
  } else {
    initMobileThumbnailsABTest();
  }

  // Check if we're on mobile (below 1008px)
  function isMobileDevice() {
    return window.innerWidth < 1008;
  }

  function initMobileThumbnailsABTest() {
    // Only run on mobile devices
    if (!isMobileDevice()) {
      return;
    }

    // Check if we're on a product page
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) {
      return;
    }

    var mobileThumbnailsNav = productSection.querySelector('.Product__SlideshowMobileNav--thumbnails');
    var mobileDotsNav = productSection.querySelector('.Product__SlideshowMobileNav--dots');
    
    if (!mobileThumbnailsNav || !mobileDotsNav) {
      return;
    }

    // Function to check IntelliGems test variant
    function checkIntelliGemsVariant() {
      // Only proceed if on mobile
      if (!isMobileDevice()) {
        return false;
      }

      // Method 1: Check for IntelliGems data attributes on body or html
      var body = document.body;
      var html = document.documentElement;
      
      // Check for data-gem-test-active attribute (common IntelliGems pattern)
      var testActive = body.getAttribute('data-gem-test-active') || 
                       html.getAttribute('data-gem-test-active') ||
                       body.getAttribute('data-gem-variant') ||
                       html.getAttribute('data-gem-variant');
      
      // Method 2: Check for IntelliGems classes
      var hasTestClass = body.classList.contains('gem-test-variant') || 
                         body.classList.contains('gem-variant-active');
      
      // Method 3: Check computed style (respects CSS media queries)
      var computedStyle = window.getComputedStyle(mobileThumbnailsNav);
      var thumbnailsVisible = computedStyle.display !== 'none' && computedStyle.display !== '';
      
      // If any method indicates test variant AND we're on mobile, show thumbnails
      if ((testActive === 'variant' || hasTestClass || thumbnailsVisible) && isMobileDevice()) {
        mobileThumbnailsNav.style.display = 'flex';
        mobileDotsNav.style.display = 'none';
        return true;
      } else {
        // Control group - show dots, hide thumbnails (only on mobile)
        if (isMobileDevice()) {
          mobileThumbnailsNav.style.display = 'none';
          mobileDotsNav.style.display = 'flex';
        }
        return false;
      }
    }

    // Initialize based on current state
    var isTestVariant = checkIntelliGemsVariant();

    // Set up thumbnail click handlers if test variant is active
    if (isTestVariant) {
      setupMobileThumbnailHandlers(productSection, mobileThumbnailsNav);
    }

    // Watch for changes (IntelliGems might update attributes dynamically)
    var observer = new MutationObserver(function(mutations) {
      // Only process if still on mobile
      if (!isMobileDevice()) {
        return;
      }
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          var newIsTestVariant = checkIntelliGemsVariant();
          if (newIsTestVariant !== isTestVariant) {
            isTestVariant = newIsTestVariant;
            if (isTestVariant && isMobileDevice()) {
              setupMobileThumbnailHandlers(productSection, mobileThumbnailsNav);
            }
          }
        }
      });
    });

    // Observe body and html for attribute changes
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-gem-test-active', 'data-gem-variant', 'class']
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-gem-test-active', 'data-gem-variant', 'class']
    });

    // Handle window resize - ensure desktop behavior is correct
    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (!isMobileDevice()) {
          // On desktop, ensure thumbnails are hidden
          mobileThumbnailsNav.style.display = 'none';
          // Don't modify dots on desktop - let CSS handle it
        } else {
          // On mobile, re-check variant
          checkIntelliGemsVariant();
        }
      }, 150);
    });

    // Also listen for custom events that IntelliGems might dispatch
    document.addEventListener('gem:variant:changed', function() {
      if (isMobileDevice()) {
        checkIntelliGemsVariant();
      }
    });
  }

  function setupMobileThumbnailHandlers(productSection, thumbnailsNav) {
    // Only set up handlers on mobile
    if (!isMobileDevice()) {
      return;
    }

    var thumbnailLinks = thumbnailsNav.querySelectorAll('.Product__SlideshowNavImage--mobile');
    var productSlideshow = productSection.querySelector('.Product__Slideshow');
    var scroller = thumbnailsNav.querySelector('.Product__SlideshowNavScroller--mobile');
    
    if (!productSlideshow || thumbnailLinks.length === 0) {
      return;
    }

    // Ensure scroller starts at the beginning (showing first thumbnails)
    if (scroller) {
      scroller.scrollLeft = 0;
    }
    
    // Ensure all thumbnails are visible (check if any are hidden)
    thumbnailLinks.forEach(function(thumb, index) {
      var computedStyle = window.getComputedStyle(thumb);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
        console.warn('Thumbnail at index', index, 'is hidden');
      }
    });

    // Handle thumbnail clicks
    thumbnailLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        var mediaId = link.getAttribute('data-media-id');
        if (!mediaId) {
          return;
        }

        // Find the corresponding slide
        var targetSlide = productSlideshow.querySelector('[data-media-id="' + mediaId + '"]');
        if (!targetSlide) {
          return;
        }

        // Update selected state
        thumbnailLinks.forEach(function(thumb) {
          thumb.classList.remove('is-selected');
        });
        link.classList.add('is-selected');

        // Scroll to the slide (if using Flickity carousel)
        var flickityInstance = productSlideshow.flickity;
        if (flickityInstance) {
          var slideIndex = Array.from(productSlideshow.querySelectorAll('.Carousel__Cell')).indexOf(targetSlide);
          if (slideIndex !== -1) {
            flickityInstance.select(slideIndex);
          }
        } else {
          // Fallback: scroll to element
          targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        // Trigger focus for accessibility
        var offset = parseInt(link.getAttribute('data-offset') || '0', 10);
        if (link.hasAttribute('data-focus-on-click')) {
          setTimeout(function() {
            targetSlide.focus();
            if (offset !== 0) {
              window.scrollBy(0, offset);
            }
          }, 100);
        }
      });
    });

    // Sync selected state when carousel changes (if Flickity is available)
    if (productSlideshow.flickity) {
      productSlideshow.addEventListener('settle', function() {
        var selectedSlide = productSlideshow.querySelector('.Carousel__Cell.is-selected');
        if (selectedSlide) {
          var selectedMediaId = selectedSlide.getAttribute('data-media-id');
          thumbnailLinks.forEach(function(thumb) {
            if (thumb.getAttribute('data-media-id') === selectedMediaId) {
              thumb.classList.add('is-selected');
            } else {
              thumb.classList.remove('is-selected');
            }
          });
        }
      });
    }
  }
})();
/* Accordion toggle fix */
(function () {
  'use strict';
  function toggleAccordion(accordion) {
    var content = accordion.querySelector(':scope > .accordion-content');
    var isActive = accordion.classList.contains('active');
    if (isActive) {
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(function () {
          accordion.classList.remove('active');
          content.style.maxHeight = '0px';
        });
      } else { accordion.classList.remove('active'); }
    } else {
      accordion.classList.add('active');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var header = event.target.closest('.accordion > .accordion-header');
    if (!header) return;
    var accordion = header.parentElement;
    if (accordion && accordion.classList.contains('accordion')) toggleAccordion(accordion);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var header = event.target.closest && event.target.closest('.accordion > .accordion-header');
    if (!header) return;
    event.preventDefault();
    toggleAccordion(header.parentElement);
  });
  (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', d) : d());
  function d() {
    document.querySelectorAll('.accordion > .accordion-header').forEach(function (h) {
      if (h.getAttribute('role') !== 'button') h.setAttribute('role', 'button');
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '0');
    });
  }
})();

